module.exports = __webpack_public_path__ + "static/parade-2020-house33-a90de7f3b2ee569e4645e45161eff989.jpg";